/* eslint-disable no-underscore-dangle */
import { fabric } from '@aibee/vincent';

const CirclePoint = fabric.util.createClass(fabric.Circle, {

  type: 'CirclePoint',
  initialize(options) {
    this.initParams(options);
    const { shapeParams = {} } = this.config;
    const graphic_data = JSON.parse(JSON.stringify(shapeParams.graphic_data || {}));
    // 导入数据的参数
    if (graphic_data.importData) {
      Object.assign(shapeParams, this.importData.style);
      if (this.importData.centerOfWhom) this.centerOfWhom = this.importData.centerOfWhom;
    }
    shapeParams.hoverCursor = 'pointer';
    shapeParams.fill = 'yellow';
    shapeParams.stroke = 'red';
    shapeParams.radius = 3;
    this.callSuper('initialize', shapeParams);
    this.initEvents();
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      property: this.property,
    });
  },

  _render(ctx) {
    this.callSuper('_render', ctx);
  },
});

Object.defineProperty(fabric, 'CirclePoint', {
  writable: false,
  value: CirclePoint,
});
